/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Session_Error_Period_OverInputs */

const fr_extra_session_error_period_over = /** @type {(inputs: Extra_Session_Error_Period_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette période est terminée.`)
};

/**

* @param {Extra_Session_Error_Period_OverInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_error_period_over = /** @type {((inputs?: Extra_Session_Error_Period_OverInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Error_Period_OverInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_error_period_over(inputs)
});